import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('blu-8022_refactor_jpd_project_menu_to_common');
	},
};
